import { addPopupAction, closePopupAction, LAYER } from 'js/components/common/PopupManager';

import { ReCaptchaPopup } from '../ReCaptchaPopup';
import * as constants from '../constants';
import * as Types from '../types';

export const showReCaptchaPopupAction = (popupData: Types.IReCaptchaPopupData) => addPopupAction({
    id: constants.RECAPTCHA_POPUP_ID,
    component: ReCaptchaPopup,
    layer: LAYER.HIGH_PRIORITY,
    ...popupData
});

export const hideReCaptchaPopupAction = () => closePopupAction(constants.RECAPTCHA_POPUP_ID);
